import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {IAdvanceFilter} from '../../../shared/advanced-filters/components/advance-filter';
import {DashboardService} from '../../dashboard/dashboard.service';
import {ContractControlAdvanceFilterParamType} from '../advanced-filters';
import {ChartOptions} from '../contract-control-cost-chart-view/contract-control-cost-chart-view.component';
import {DefaultFilter} from '../contract-control-interfaces/default-filters.interface';
import {ContractControlService, IGraphDataUpcomingEvents} from '../contract-control.service';

@Injectable({
    providedIn: 'root'
})


export class UpComingGraphService {
    constructor (
        private contractControlService: ContractControlService,
        private dashboardService: DashboardService
    ) {}



    /**
     * Handle upcoming graph request
     * @param contract_id 
     * @returns 
     */
    handleGraphRequests(contract_id: number = 0): Observable<IGraphDataUpcomingEvents>{
        if(contract_id != 0){
            return this.fetchUpComingGraphForContract(contract_id);
        }else {
            return this.fetchUpComingGraphs(6,null);
        }
    }



    /**
     * Fetching upcoming graph for specific contract
     * @param contract_id
     * @param filter
     */
    fetchUpComingGraphForContract(contract_id: number, filter: number = 6): Observable<IGraphDataUpcomingEvents>{
        const upComingGraph = [];
        return new Observable(observer => {
            this.contractControlService.upcomingEvents(contract_id, filter).subscribe((response) => {
                const periodRenewalEvents = [];
                const months = this.generateMonthsWithFilter(filter);
                if (response.periodRenewalEvents != undefined && response.periodRenewalEvents != null) {
                    if (Object.prototype.hasOwnProperty.call(response.periodRenewalEvents, 'auto_notice'))
                        periodRenewalEvents.push(response.periodRenewalEvents.auto_notice);
                    if (Object.prototype.hasOwnProperty.call(response.periodRenewalEvents, 'auto_renew'))
                        periodRenewalEvents.push(response.periodRenewalEvents.auto_renew);
                    if (Object.prototype.hasOwnProperty.call(response.periodRenewalEvents,'notice'))
                        periodRenewalEvents.push(response.periodRenewalEvents.notice);
                    if (Object.prototype.hasOwnProperty.call(response.periodRenewalEvents,'expire'))
                        periodRenewalEvents.push(response.periodRenewalEvents.expire);
                }
    
                const todoData = {};
                let maxCount = 3;
                for (let i = 0; i < response?.todoEvents?.length; i++) {
                    const eventData = response.todoEvents[i];
                    if (!Object.prototype.hasOwnProperty.call(todoData,eventData.label)) {
                        todoData[eventData.label] = [];
                    }
                    todoData[eventData.label].push(eventData);
                    if (maxCount < todoData[eventData.label].length)
                        maxCount = todoData[eventData.label].length;
                }
    
                const periodRenewalData = [];
                const periodRenewalData2 = [];
                const todoGraphData = [];
                for (let i = 0; i < months.length; i++) {
                    if (response.periodRenewalEvents != undefined && response.periodRenewalEvents != null && periodRenewalEvents.length > 0 && months[i] == periodRenewalEvents[0].label) {
                        periodRenewalData.push({
                            x: periodRenewalEvents[0].expiration_date,
                            y: 1,
                            allData: periodRenewalEvents[0],
                            type: 'periodrenewal'
                        });
    
                    }
                    else {
                        periodRenewalData.push({
                            x: '',
                            y: 0
                        });
                    }
    
                    if (response.periodRenewalEvents != undefined && response.periodRenewalEvents != null && periodRenewalEvents.length > 1 && months[i] == periodRenewalEvents[1].label) {
                        periodRenewalData2.push({
                            x: periodRenewalEvents[1].expiration_date,
                            y: 1,
                            allData: periodRenewalEvents[1],
                            type: 'periodrenewal'
                        });
    
                    }
                    else {
                        periodRenewalData2.push({
                            x: '',
                            y: 0
                        });
                    }
    
                    if ( Object.prototype.hasOwnProperty.call(todoData, months[i]))
                        todoGraphData.push({
                            x: todoData[months[i]][0].expiration_date,
                            y: todoData[months[i]].length,
                            allData: todoData[months[i]],
                            type: 'todo'
                        });
                    else
                        todoGraphData.push({
                            x: '',
                            y: 0
                        });
                }
    
                const graphData = [];
                if (todoGraphData.length) {
                    graphData.push({ name: "Activities", data: todoGraphData });
                }
    
                if (periodRenewalEvents && periodRenewalEvents != null && periodRenewalEvents.length > 0) {
                    graphData.push({ name: periodRenewalEvents[0]?.activity, data: periodRenewalData });
                }
    
                if (periodRenewalEvents && periodRenewalEvents != null && periodRenewalEvents.length > 1) {
                    graphData.push({ name: periodRenewalEvents[1]?.activity, data: periodRenewalData2 });
                }
                upComingGraph['graphData'] = graphData;
                upComingGraph['maxCount'] = maxCount;
                upComingGraph['months'] = months;

                // After populating the data, emit upComingGraph through the observer
                observer.next(upComingGraph);
                observer.complete();
            });
        });
    }



    /**
     * Fetching upcoming graph for dashboard widget
     * @param monthsFilter
     * @param filter
     * @param advancedFilter
     */
    fetchUpComingGraphs(monthsFilter: number = 6, filter: DefaultFilter, advancedFilter?: IAdvanceFilter<ContractControlAdvanceFilterParamType>[]): Observable<IGraphDataUpcomingEvents>{
        const upComingGraph:Partial<ChartOptions> = {};
        return new Observable(observer => {
            this.dashboardService.upcomingEvents(monthsFilter,filter, advancedFilter).subscribe((response) => {
                let periodRenewalEvents = [];
                const months = this.generateMonthsWithFilter(monthsFilter);
                const todoData = {};
                const tempGraphData = {};
                for (let k = 0; k < response.length; k++) {

                    if (response[k].periodRenewalEvents != undefined && response[k].periodRenewalEvents != null) {
                        periodRenewalEvents = [];
                        if (Object.prototype.hasOwnProperty.call(response[k].periodRenewalEvents,'auto_notice') )
                            periodRenewalEvents.push(response[k].periodRenewalEvents.auto_notice);
                        if (Object.prototype.hasOwnProperty.call(response[k].periodRenewalEvents,'auto_renew'))
                            periodRenewalEvents.push(response[k].periodRenewalEvents.auto_renew);
                        if (Object.prototype.hasOwnProperty.call(response[k].periodRenewalEvents,'notice'))
                            periodRenewalEvents.push(response[k].periodRenewalEvents.notice);
                        if (Object.prototype.hasOwnProperty.call(response[k].periodRenewalEvents,'expire'))
                            periodRenewalEvents.push(response[k].periodRenewalEvents.expire);
                    }

                    for (let i = 0; i < response[k]?.todoEvents?.length; i++) {
                        const eventData = response[k].todoEvents[i];
                        if (!Object.prototype.hasOwnProperty.call(todoData,eventData.label)) {
                            todoData[eventData.label] = [];
                        }
                        todoData[eventData.label].push(eventData);
                    }

                    for (let i = 0; i < months.length; i++) {

                        if (response[k].periodRenewalEvents != undefined && response[k].periodRenewalEvents != null && periodRenewalEvents.length > 0 && months[i] == periodRenewalEvents[0].label) {

                            if(! Object.prototype.hasOwnProperty.call(tempGraphData,periodRenewalEvents[0]['activity'] ))
                                tempGraphData[periodRenewalEvents[0]['activity']] = {};

                            if(! Object.prototype.hasOwnProperty.call(tempGraphData[periodRenewalEvents[0]['activity']], months[i]))
                                tempGraphData[periodRenewalEvents[0]['activity']][months[i]] = [];

                            tempGraphData[periodRenewalEvents[0]['activity']][months[i]].push(periodRenewalEvents[0]);
                        }

                        if (response[k].periodRenewalEvents != undefined && response[k].periodRenewalEvents != null && periodRenewalEvents.length > 1 && months[i] == periodRenewalEvents[1].label) {

                            if(! Object.prototype.hasOwnProperty.call(tempGraphData,periodRenewalEvents[1]['activity']))
                                tempGraphData[periodRenewalEvents[1]['activity']] = {};

                            if(! Object.prototype.hasOwnProperty.call(tempGraphData[periodRenewalEvents[1]['activity']],months[i]))
                                tempGraphData[periodRenewalEvents[1]['activity']][months[i]] = [];

                            tempGraphData[periodRenewalEvents[1]['activity']][months[i]].push(periodRenewalEvents[1]);
                        }
                    }
                }

                let maxCount = 4;
                const monthsWiseData = {};
                const graphDataNew = [];
                const todoGraphData = [];
                for (let i = 0; i < months.length; i++)
                {
                    if(!Object.prototype.hasOwnProperty.call(monthsWiseData,months[i]))
                        monthsWiseData[months[i]] = 0;

                    if (Object.prototype.hasOwnProperty.call(todoData,months[i]) && todoData[months[i]][0].expiration_date != null && todoData[months[i]][0].expiration_date != '')
                    {
                        todoGraphData.push({
                            x: todoData[months[i]][0].expiration_date,
                            y: todoData[months[i]].length,
                            allData: todoData[months[i]],
                            type: 'todo'
                        });
                        monthsWiseData[months[i]] = monthsWiseData[months[i]] + todoData[months[i]].length;
                        if (maxCount < monthsWiseData[months[i]])
                            maxCount = monthsWiseData[months[i]];
                    }
                    else
                    {
                        todoGraphData.push({
                            x: '',
                            y: 0
                        });
                    }
                }
                graphDataNew.push({ name: 'Activities', data: todoGraphData });
                Object.entries(tempGraphData).forEach(([key, value]) => {
                    const groupDataMonths = [];
                    for (let i = 0; i < months.length; i++) 
                    {
                        if(!Object.prototype.hasOwnProperty.call(monthsWiseData,months[i]))
                            monthsWiseData[months[i]] = 0;

                        if(Object.prototype.hasOwnProperty.call(value,months[i]) && value[months[i]][0].expiration_date != null && value[months[i]][0].expiration_date != '')
                        {
                            groupDataMonths.push({
                                x: value[months[i]][0].expiration_date,
                                y: value[months[i]].length,
                                allData: value[months[i]],
                                type: 'all_types'
                            });      
                                
                            monthsWiseData[months[i]] = monthsWiseData[months[i]] + value[months[i]].length;

                            if (maxCount < monthsWiseData[months[i]])
                                maxCount = monthsWiseData[months[i]];
                        }
                        else
                        {
                            groupDataMonths.push({
                                x: '',
                                y: 0
                            });                
                        }
                    }
                    graphDataNew.push({ name: key, data: groupDataMonths });
                });
                upComingGraph['graphData'] = graphDataNew;
                upComingGraph['maxCount'] = maxCount;
                upComingGraph['months'] = months;
                observer.next(upComingGraph);
                observer.complete();
            });
        });
    }
    
    /**
     * Generate months array with filter
     * @param filter 
     * @returns array
     */
    generateMonthsWithFilter(filter: number = 12): string[] {
        const currentMonth = new Date().getMonth() + 1;
        const dataPoints = [];
        for (let i = 0; i < filter; i++) {
            const monthIndex = currentMonth + i;
            const monthLabel = new Date(new Date().getFullYear(), monthIndex - 1, 1).toLocaleString('en-us', { month: 'short' });
            dataPoints.push(monthLabel);
        }
        return dataPoints;
    }
}
